import React from 'react'
import './Template.scss'

function Template() {
  return (
    <section className="template-designer-container">
      <div className="template-divider"></div>
    </section>
  )
}

export default Template
